import { Typography } from '@mui/material'
import React from 'react'

function AccessDinied() {
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <Typography color='error'>
                Accès refusé
            </Typography>
        </div>
    )
}

export default AccessDinied